import assignApi from './ugcAssignmentApi';
import { delay } from 'redux-saga';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import {
  requestAssignment,
  receiveAssignment,
  clearChangeStatus,
  clearAssignment,
} from './ugcAssignmentReducer';
import { selectToken, boundedDelay } from 'ducks/SagaUtils';
import { type ActionType } from 'redux-actions';
import { updateUgc } from 'ducks/coreDataActions';

export default function* saga() {
  yield takeEvery(requestAssignment, requestAssignmentSaga);
}

function* requestAssignmentSaga(
  action: ActionType<typeof requestAssignment>
): Generator<*, *, *> {
  const token = yield select(selectToken);
  const {
    payload: { ugcId },
    payload,
  } = action;

  const startTs = Date.now();

  try {
    yield call(assignApi, token, action.payload);
    yield call(delay, boundedDelay(startTs));
    yield put(updateUgc({ assigned_to: payload.profileId }, ugcId));
    yield put(clearAssignment(ugcId));
  } catch (err) {
    yield put(receiveAssignment(err, ugcId));
    yield call(delay, 1000);
    yield put(clearChangeStatus(ugcId));
  }
}



// WEBPACK FOOTER //
// ./src/containers/client/ugcAssignmentSaga.js